import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'management-reports-sales-products-current-status-mirror',
  storeModule.createStoreModule('management-reports-sales-products-current-status-mirror')
)
